import React         from 'react'
import prettysize    from '../../../utils'
import { Draggable } from 'react-beautiful-dnd'
import classnames    from "classnames"
import { Checkbox, Button, Icon, Tooltip } from 'antd'

import './styles.scss'

let is_supported_video_format = filename =>
    ['mp4', 'webm', 'weba', 'ogv', 'mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'm4p', 'ogg', 'mpa']
        .indexOf((filename.split('.').pop()||'').toLowerCase()) >= 0

let get_item_style = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    background: isDragging ? '' : '',
    ...draggableStyle
})

// export default ({file, selection_count, on_play_video, on_select, on_download, on_delete,
//                     on_share, on_open_encode, on_expand_options, is_ghosting,
//                     on_navigate, on_open_hybrik, on_show_media_info, on_move, index, droppable_id,
//                     is_drag_disabled, user }) 
export default ({file, on_navigate, droppable_id, index, is_drag_disabled}) => {
    // console.log("in files", file);
    // let {key, basename, name, path, size, type} = file
    let {key, name, path, size, type} = file
    // basename = basename||key||name
    // const is_video  = is_supported_video_format(basename)
    // const { is_cbs } = user.organization;
    let move_target = null

    return <Draggable 
                draggableId={droppable_id + file.path}
                key={droppable_id + file.path}
                index={index}
                isDragDisabled={is_drag_disabled}
                >
        {(provided, snapshot) => {
            return (
                <a className={classnames({
                    'file-item': true,
                    'columnWrap': true,
                    'checked': file.checked,
                    // 'ghosting': file.checked && is_ghosting,
                    'dragging': snapshot.isDragging,
                    'pasted': file.pasted
                })}
                   onDoubleClick={() => type === 2 ? on_navigate(file): null}
                //    onClick={() => on_select(file, !file.checked)}
                   ref={provided.innerRef}
                   {...provided.draggableProps}
                   {...provided.dragHandleProps}
                   style={get_item_style(
                       snapshot.isDragging,
                       provided.draggableProps.style
                   )}>

                    {type === 1 ? <Icon type="file-text"/> : <Icon type="folder"/>}
                    <span>
                        {
                            (name.length > 70) ?
                            <Tooltip placement="topLeft" title={name}>
                                {name.substring(0, 70)}
                            </Tooltip>
                            :
                            name
                        }

                        
                    </span>
                    {

                        
                        type === 1 ?
                            file.expand_options ? (
                                <div className={'options ' + file.expand_options ? 'expand' : ''}>

                                    <Tooltip title="Media Info">
                                        <Button ghost icon="info-circle-o" size={'small'}
                                                // onClick={() => on_show_media_info(file)}
                                        />
                                    </Tooltip>

                                    {/*<MovePopover ref={n => move_target = n} target={
                                          <Tooltip title="Move to">
                                            <Button ghost shape="circle" size={'small'} onClick={() => on_move(move_target, [file])}>
                                              <svg className="a-s-If-c a-s-fa-Ha-pa" width="24px" height="24px" viewBox="0 0 24 24"
                                                   focusable="false" fill="white">
                                                <path fill="none" d="M0 0h24v24H0V0z"/>
                                                <path fill='white'
                                                      d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 12v-3h-4v-4h4V8l5 5-5 5z"/>
                                              </svg>
                                            </Button>
                                          </Tooltip>
                                        }/>
                                        */}

                                    {/*<Tooltip title="Share this file">
                                          <Button ghost icon="share-alt" size={'small'} onClick={() => on_share(file)}/>
                                        </Tooltip>*/}

                                    {
                                        // is_video &&
                                        <Tooltip title="Play video">
                                            <Button ghost icon="play-circle-o" size={'small'}
                                                    // onClick={() => on_play_video(file)}
                                                    />
                                        </Tooltip>
                                    }

                                    {/*{
                                        is_cbs && on_open_hybrik && <Tooltip title="Encode using Hybrik">
                                            <Button ghost icon="fork" size={'small'} onClick={()=> on_open_hybrik(file, 'Hybrik')}/>
                                        </Tooltip>
                                    }*/}

                                    {/*<Tooltip title="Encode using Hybrik">
                                          <Button ghost icon="fork" size={'small'} onClick={()=> on_open_hybrik(file, 'Hybrik')}/>
                                        </Tooltip>*/}

                                    {/*<Tooltip title="Encode this file using Hybrik">
                                          <Button ghost size={'small'}  onClick={()=> on_open_hybrik(file, 'Hybrik')}>
                                            <img src={hybrikIcon} className={'icon hybrik'} />
                                          </Button>
                                        </Tooltip>

                                        <Tooltip title="Encode this file using encoding.com">
                                          <Button ghost size={'small'}  onClick={()=> on_open_encode(file)}>
                                            <img src={encodeIcon} className={'icon'} />
                                          </Button>
                                        </Tooltip>*/}

                                    {/* <Popconfirm title={'Are you sure to delete ' + basename + ' ?'} placement="top" okText="Yes"
                                                    cancelText="No" onConfirm={() => on_delete(file)}>
                                          <Button ghost icon="delete" size={'small'}/>
                                        </Popconfirm>
                                        <Button ghost icon="download" size={'small'} onClick={() => on_download(file)}/>*/}
                                    <Button ghost 
                                        icon="close" 
                                        size={'small'} 
                                        // onClick={() => on_expand_options(file)}
                                        />
                                </div>
                            ) : (
                                <div className={'cmds'}>
                                    <span className='size'>{prettysize(size)}</span>
                                    {/* <Checkbox checked={file.checked} 
                                        // onChange={(e) => on_select(file, e.target.checked)}
                                        />
                                    <Button icon="ellipsis" size={'small'} className={'ellipsis'}
                                            // onClick={() => on_expand_options(file)}
                                            /> */}
                                </div>
                            ) : null
                    }
                    {
                        // (selection_count > 1 && snapshot.isDragging && file.checked) ?
                        //     <div className={'badge'}>{selection_count}</div> : null
                    }
                </a>
            )
        }}
    </Draggable>
}
